export default __webpack_public_path__ + "static/media/grafema_SET_08.29ad5dc6.jpg";